module.exports = __webpack_public_path__ + "img/ielts.cda9ee17.png";